/**
 * Upload Path Item File API
 * POST /api/path-items/{itemId}/upload (multipart, field name 'file')
 *
 * Document-upload learner flow. Identity from token. When the item is
 * self-attested (requiresReview=false) the completion is written
 * immediately and returned alongside the upload summary.
 */

import axiosInstance from "../axiosInstance";

export interface PathItemUploadSummary {
  id: number;
  originalFilename: string;
  mimeType: string;
  fileSizeBytes: number;
  reviewStatus: string | null;
  createdAt: string;
}

export interface UploadPathItemFileResponse {
  upload: PathItemUploadSummary;
  completion: {
    completedAt: string;
    completedByUserId: number | null;
    completedByName: string;
    source: string;
    taskData: Record<string, unknown> | null;
  } | null;
}

interface UploadPathItemFileEnvelope {
  data: UploadPathItemFileResponse;
}

export const uploadPathItemFile = async (
  itemId: number,
  file: File,
): Promise<UploadPathItemFileResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post<UploadPathItemFileEnvelope>(
    `/api/path-items/${itemId}/upload`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );

  return response.data.data;
};
